export enum SupportedLocales {
    'da' = 'da',
    'de' = 'de',
    'en-au' = 'en-au',
    'en-ca' = 'en-ca',
    'en-in' = 'en-in',
    'en-us' = 'en-us',
    'en' = 'en',
    'es-mx' = 'es-mx',
    'es' = 'es',
    'fi' = 'fi',
    'fr-ca' = 'fr-ca',
    'fr' = 'fr',
    'hi' = 'hi',
    'it' = 'it',
    'ja' = 'ja',
    'ko' = 'ko',
    'nb' = 'nb',
    'nl' = 'nl',
    'pl' = 'pl',
    'pt-pt' = 'pt-pt',
    'pt' = 'pt',
    'ru' = 'ru',
    'sv' = 'sv',
    'zh-Hant' = 'zh-Hant',
    'zh' = 'zh',
}
